// Firebase config
/******************

   TEXT TRANSLATIONS

*******************/

var parser = {

  extractNumber: function(text) {
    if (text) {
      if (!isNaN(text)) {
        return Number(text);
      };
      let number_arr = text.match(/\d+/);
      if (number_arr) {
        return number_arr.join('');
      } else {
        return '';
      };
    } else {
      return '';
    };
  },

}

export { parser };
